// Core Web Vitals collection. Wires the three field metrics the backend ingests
// (LCP — load, INP — interactivity, CLS — layout stability) into a single reporter
// that maps each `web-vitals` Metric to the generated `RumVital` wire shape. Each
// metric reports at most once per page by default (web-vitals batches CLS/INP and
// emits the final value on hide), so the queue stays tiny.

import { onCLS, onINP, onLCP, type Metric } from "web-vitals";

import type { RumVital } from "./types";

/** Register `onVital` to receive each Core Web Vital as it becomes final. */
export function registerVitals(onVital: (vital: RumVital) => void): void {
  const report = (metric: Metric): void => {
    onVital({
      name: metric.name,
      value: metric.value,
      rating: metric.rating,
      id: metric.id,
    });
  };
  onLCP(report);
  onINP(report);
  onCLS(report);
}
